/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.admin.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetAvailableTemplateFrameworksQueryVariables = Types.Exact<{
  orgFrameworks: Array<Types.Scalars['uuid']['input']> | Types.Scalars['uuid']['input'];
}>;

export type GetAvailableTemplateFrameworksQuery = {
  __typename?: 'query_root';
  template_frameworks: Array<{ __typename?: 'template_frameworks'; id: string; name: string }>;
};

export type RemoveOrgTemplateFrameworkMutationVariables = Types.Exact<{
  organization_id: Types.Scalars['uuid']['input'];
  template_framework_id: Types.Scalars['uuid']['input'];
}>;

export type RemoveOrgTemplateFrameworkMutation = {
  __typename?: 'mutation_root';
  delete_organization_template_frameworks_by_pk?: {
    __typename?: 'organization_template_frameworks';
    template_framework_id: string;
  } | null;
};

export type AddOrgTemplateFrameworkMutationVariables = Types.Exact<{
  input: Types.Organization_Template_Frameworks_Insert_Input;
}>;

export type AddOrgTemplateFrameworkMutation = {
  __typename?: 'mutation_root';
  insert_organization_template_frameworks_one?: {
    __typename?: 'organization_template_frameworks';
    template_framework_id: string;
  } | null;
};

export const GetAvailableTemplateFrameworksDocument = `
    query GetAvailableTemplateFrameworks($orgFrameworks: [uuid!]!) {
  template_frameworks(
    where: {_and: {active: {_eq: true}, id: {_nin: $orgFrameworks}}}
  ) {
    id
    name
  }
}
    ` as string &
  TypedDocumentNode<
    GetAvailableTemplateFrameworksQuery,
    GetAvailableTemplateFrameworksQueryVariables
  >;
export const RemoveOrgTemplateFrameworkDocument = `
    mutation RemoveOrgTemplateFramework($organization_id: uuid!, $template_framework_id: uuid!) {
  delete_organization_template_frameworks_by_pk(
    organization_id: $organization_id
    template_framework_id: $template_framework_id
  ) {
    template_framework_id
  }
}
    ` as string &
  TypedDocumentNode<
    RemoveOrgTemplateFrameworkMutation,
    RemoveOrgTemplateFrameworkMutationVariables
  >;
export const AddOrgTemplateFrameworkDocument = `
    mutation AddOrgTemplateFramework($input: organization_template_frameworks_insert_input!) {
  insert_organization_template_frameworks_one(object: $input) {
    template_framework_id
  }
}
    ` as string &
  TypedDocumentNode<AddOrgTemplateFrameworkMutation, AddOrgTemplateFrameworkMutationVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetAvailableTemplateFrameworks: build.query<
      GetAvailableTemplateFrameworksQuery,
      GetAvailableTemplateFrameworksQueryVariables
    >({
      query: (variables) => ({ document: GetAvailableTemplateFrameworksDocument, variables }),
    }),
    RemoveOrgTemplateFramework: build.mutation<
      RemoveOrgTemplateFrameworkMutation,
      RemoveOrgTemplateFrameworkMutationVariables
    >({
      query: (variables) => ({ document: RemoveOrgTemplateFrameworkDocument, variables }),
    }),
    AddOrgTemplateFramework: build.mutation<
      AddOrgTemplateFrameworkMutation,
      AddOrgTemplateFrameworkMutationVariables
    >({
      query: (variables) => ({ document: AddOrgTemplateFrameworkDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useGetAvailableTemplateFrameworksQuery,
  useLazyGetAvailableTemplateFrameworksQuery,
  useRemoveOrgTemplateFrameworkMutation,
  useAddOrgTemplateFrameworkMutation,
} = injectedRtkApi;
